<template>
	<div class="main-content">
		<!-- HEADER -->
		<div class="header">
			<div class="container-fluid">
				<div class="card mt-5">
					<div class="card-body">
						<div class="row justify-content-between align-items-center">
							<div class="col-12 col-md-9 col-xl-7">
								<!-- Heading -->
								<h2 class="mb-2">My Plan</h2>

								<!-- Text -->
								<p class="text-muted mb-md-0">All your budget plan</p>
								<div>
									<p class="mb-md-0"><b>Plan Info</b></p>
									<p class="mb-md-0">Budget Plan Title: {{ this.activePlan?.title }}</p>
									<p class="mb-md-0">
										Department:
										{{ this.activePlan?.fund_center?.department_code }} -
										{{ this.activePlan?.fund_center?.department_name }}
									</p>
									<p class="mb-md-0">Year: {{ this.activePlan?.year }}</p>
									<p class="mb-md-0">Version: {{ this.activePlan?.version }}</p>
								</div>
							</div>
							<div class="col-md-auto"></div>
						</div>
					</div>
				</div>
				<b-card no-body class="mb-4">
					<b-card-header header-tag="header" class="p-4">
						<div class="d-flex justify-content-between">Export Budget Plan</div>
					</b-card-header>
					<b-card-body>
						<div class="row ml-1">
							<div class="form-group col-7 align-items-start pl-0">
								<label>Department</label>
								<multiselect
									v-model="value"
									:options="options"
									:multiple="true"
									:close-on-select="false"
									:clear-on-select="false"
									:preserve-search="true"
									placeholder="Select/Type Here..."
									:custom-label="customLabel"
									track-by="id"
								>
									<!--
                  label="name"
                    track-by="id"
                  :preselect-first="false"
                  :show-labels="false"
                  @select="handleSelect"
                  @remove="handleRemove"
                  -->
									<!-- Select All Checkbox -->
									<template #beforeList>
										<div class="multiselect__option">
											<input type="checkbox" :checked="isAllSelected" @change="toggleSelectAll" />
											<span style="margin-left: 6px">Select All</span>
										</div>
									</template>
									<template slot="selection" slot-scope="{ values, search, isOpen }">
										<span class="multiselect__single" v-if="values.length" v-show="!isOpen">
											{{ values.length }} Department selected
										</span>
									</template>

									<!-- Custom option with checkbox -->
									<!--                  <template #option="{ option }">
                                      <div>
                                        <input
                                            type="checkbox"
                                            :checked="isSelected(option)"
                                        />
                                        <span style="margin-left: 6px;">{{ option.row.department_name }}</span>
                                      </div>
                                    </template>-->
								</multiselect>
								<!--                <v-select
                                    :options="listDepartment"
                                    v-model="formFilter.department"
                                    :reduce="(e) => e.row.department_code"
                                    placeholder="Select/Type Here..."
                                    class="w-md-auto"
                                    multiple
                                    chips
                                    outlined
                                />-->
							</div>
							<div class="form-group col-3 align-items-start pl-0">
								<label>Year <span class="text-danger">*</span></label>
								<v-select style="line-height: 2" :options="listDataYear" :reduce="(e) => e.value" v-model="formFilter.year" />
							</div>
							<div class="form-group col-auto align-items-end pl-0">
								<div class="mt-3 pt-3">
									<b-button variant="primary" @click="filterBudgetPlanExcel()">Export to excel </b-button>
								</div>
							</div>
						</div>
						<div class="row" v-if="isDepartmentError">
							<div class="col-7">
								<div class="card">
									<div class="row m-0 p-0" style="margin-right: -15px !important; padding-right: -15px !important">
										<div class="col-11"></div>
										<div class="col-auto align-items-end mt-2 pt-2 mb-0 pb-0">
											<i class="fe fe-x-circle text-danger" style="cursor: pointer; font-size: 20px" @click="hideFormError"></i>
										</div>
									</div>

									<div class="card-body text-danger" style="margin-top: -35px !important; padding-top: -35px !important">
										<b>Warning ! : Budget plan department tahun {{ this.formFilter.year }} belum dibuat </b> <br />
										Department : <br />
										<ul v-for="(item, index) in listDataDepartmentError" :key="index" class="ml-3 pl-3">
											<li class="mt-1 mb-0">
												{{ item.name }}
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</b-card-body>
				</b-card>
				<!-- Body -->
			</div>
		</div>
		<!-- / .header -->

		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<!-- <div class="card">
            <div class="card-header">
              Filter Budget Plan
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-4">
                  <label for="year">Year</label>
                  <v-select
                    :options="years"
                    v-model="filters.year"
                    placeholder="Years"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label for="title">Title</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search by title"
                    v-model="filters.title"
                  />
                </div>
                <div class="col-md-12">
                  <label for="department">Departemen</label>
                  <v-select
                    :options="listFundCenter.data" 
                    v-model="filters.department"
                    placeholder="Departemen"
                    :reduce="(e) => e.id"
                    :get-option-label="option => option ? `${option.department_code} - ${option.department_name}` : ''"
                  ></v-select>
                </div>
              </div>
              <div class="text-end">
                <b-button
                  variant="primary"
                  @click="applyFilter">
                  Filter
                </b-button>
              </div>
            </div>
          </div> -->
					<div class="card">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col">
									<!-- Title -->
									<h4 class="card-header-title">Create Budget Plan</h4>
								</div>
								<div class="col-auto align-items-end">
									<button
										v-if="canReply"
										class="btn btn-outline-primary mr-2 mb-2 mb-lg-0"
										@click="showModalNotification('respond')"
									>
										Respond Reminder
									</button>
									<button
										v-if="canSendNotif"
										class="btn btn-outline-primary mr-2 mb-2 mb-lg-0"
										@click="showModalNotification('reminder')"
									>
										Reminder Budget Next Year
									</button>
									<button class="btn btn-primary" @click.prevent="handleClickCreatePlan">Create Plan</button>
								</div>
							</div>
							<!-- / .row -->
						</div>
						<div class="card-body">
							<div class="row">
								<div class="form-group col-4 align-items-start pl-0">
									<label>Department</label>
									<!-- {{ listFundCenter }}/ -->
									<v-select
										:options="listDepartment"
										v-model="body.fund_center_id"
										:reduce="(e) => e.value"
										placeholder="Select/Type Here..."
										class="w-md-auto"
										@input="selectFundCenter"
									/>
								</div>
								<div class="form-group col-4 align-items-start pl-0 mt-4">
									<!--
                  <button
                      class="btn btn-outline-primary mr-2 mb-2 mb-lg-0 mt-1"
                  >
                    Import excel
                  </button>
                  -->
									<button class="btn btn-outline-primary mr-2 mb-2 mb-lg-0 mt-1" @click="downloadTemplate()">
										Download template
									</button>
									<button class="btn btn-outline-primary mr-2 mb-2 mb-lg-0 mt-1" @click="handleImport()">Import excel</button>
								</div>
							</div>
							<!--              <vue-good-table v-if="role_id == 'User' || role_id == 'Viewer'" :line-numbers="true" :columns="columns" :rows="listTable" :sort-options="{
                    enabled: true,
                    }" :total-rows="listTable.totalItems" :pagination-options="{
                    enabled: true,
                    perPage: body.perPage,
                    }" style-class="vgt-table border-0 table" @on-page-change="onPageChange"
                @on-per-page-change="onPageChange" @on-sort-change="onSortChange">
                &lt;!&ndash; Loading &ndash;&gt;
                <div slot="emptystate" class="text-center font-size-14">
                  No data available
                </div>
                &lt;!&ndash; Custom Rows &ndash;&gt;
                <template slot="table-row" slot-scope="props">
                  &lt;!&ndash; Table Action &ndash;&gt;
                  <span v-if="props.column.field == 'action'">
                    <b-button class="no-wrap btn-pill mr-2" variant="info" size="sm" @click="detailBudget(props.row.id)"
                      v-b-popover.hover="'Detail'">
                      <span class="fe fe-info"></span>
                    </b-button>
                    <b-button class="no-wrap mr-2" variant="secondary" size="sm" v-b-popover.hover="'Compare'"
                      @click="compareBudget(props.row.id)">
                      <span class="fe fe-git-branch"></span>
                    </b-button>
                    <b-button v-if="role_id == 'Super Admin' || role_id == 'Admin'" class="no-wrap btn-pill" variant="warning" size="sm"
                      v-b-popover.hover="'Update'" @click="updateBudget(props.row.id)">
                      <span class="fe fe-edit"></span>
                    </b-button>
                    <b-button v-if="role_id == 'Super Admin' || role_id == 'Admin'" class="no-wrap ml-2" variant="danger" v-b-popover.hover="'Delete'"
                      style="margin-left: 5px" size="sm" @click="deleteData(props.row.id)">
                      <span class="fe fe-trash-2"></span>
                    </b-button>
                    &lt;!&ndash; <ToggleSwitch v-model="isOnToggleSwitch" /> &ndash;&gt;
                  </span>
                  <span v-else-if="props.column.field == 'total'">
                    Rp. {{ convertNumber(props.row.total) }}
                  </span>
                  &lt;!&ndash; <span v-else-if="props.column.field == 'title'">
                    {{ props.row.title }}
                    <span v-if="props.row.is_active === true" class="badge bg-success-soft">ACTIVE</span>
                  </span> &ndash;&gt;
                  <span v-else-if="props.column.field == 'is_active'">
                    <span v-if="props.row.is_active === true" class="badge bg-success-soft">ACTIVE</span>
                  </span>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination :value="1" :total-rows="listTable.totalItems" :per-page="body.pageSize" first-number
                        last-number align="right" prev-class="prev-item" next-class="next-item" class="mr-3 mb-4 mt-0"
                        @input=" (value) => props.pageChanged({ currentPage: value })">
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>-->
							<vue-good-table
								:line-numbers="true"
								:columns="columns"
								:rows="listTable.data"
								:sort-options="{
									enabled: true,
								}"
								:total-rows="listTable.totalItems"
								:pagination-options="{
									enabled: true,
									perPage: body.perPage,
								}"
								style-class="vgt-table border-0 table"
								@on-page-change="onPageChange"
								@on-per-page-change="onPageChange"
								@on-sort-change="onSortChange"
							>
								<!-- Loading -->
								<div slot="emptystate" class="text-center font-size-14">No data available</div>
								<!-- Custom Rows -->
								<template slot="table-row" slot-scope="props">
									<!-- Table Action -->
									<span v-if="props.column.field == 'version'">
										{{ props.row.version }}
										<span class="ml-3 fe fe-lock" v-if="props.row.locked" style="color: red"></span>
									</span>
									<span v-if="props.column.field == 'action'">
										<b-dropdown id="dropdown-dropleft" dropleft variant="primary" class="m-2">
											<b-dropdown-item class="hovering" @click="detailBudget(props.row.id)"> View Detail </b-dropdown-item>
											<b-dropdown-item class="hovering" v-if="isUpdate" @click="compareBudget(props.row.id)">
												Compare
											</b-dropdown-item>
											<b-dropdown-item class="hovering" v-if="canLockUnlock" @click="toogleLock(props.row.id, props.row.locked)">
												{{ props.row?.locked ? 'Unlock' : 'Lock' }}
											</b-dropdown-item>
											<b-dropdown-item
												class="hovering"
												v-if="canClone && props.row.locked && props.row.version < 5"
												@click="cloning(props.row)"
											>
												Clone
											</b-dropdown-item>
											<b-dropdown-item
												class="hovering"
												v-if="canRequestApproval && !props.row.been_approved"
												@click="showModalNotification('request_approval', props.row)"
											>
												Request Approval
											</b-dropdown-item>
											<b-dropdown-item
												class="hovering"
												v-if="canRequestClone && props.row.version < 5"
												@click="showModalNotification('request_clone', props.row)"
											>
												Request Clone
											</b-dropdown-item>
											<b-dropdown-item v-if="isUpdate && !props.row.locked" class="hovering" @click="updateBudget(props.row.id)">
												Edit
											</b-dropdown-item>
											<b-dropdown-item class="hovering" @click="goToHistory(props.row.id)"> Historical Log </b-dropdown-item>
											<b-dropdown-item v-if="isDelete" class="hovering" @click="deleteData(props.row.id)">
												Delete
											</b-dropdown-item>
										</b-dropdown>
										<!-- <b-button class="no-wrap btn-pill mr-2" variant="info" size="sm" @click="detailBudget(props.row.id)"
                      v-b-popover.hover="'Detail'">
                      <span class="fe fe-info"></span>
                    </b-button>
                    <b-button v-if="role_id == 'Super Admin' || role_id == 'Admin'" class="no-wrap mr-2" variant="secondary" size="sm" v-b-popover.hover="'Compare'"
                      @click="compareBudget(props.row.id)">
                      <span class="fe fe-git-branch"></span>
                    </b-button>
                    <b-button v-if="role_id == 'Super Admin' || role_id == 'Admin'" class="no-wrap btn-pill" variant="warning" size="sm"
                      v-b-popover.hover="'Update'" @click="updateBudget(props.row.id)">
                      <span class="fe fe-edit"></span>
                    </b-button>
                    <b-button v-if="role_id == 'Super Admin' || role_id == 'Admin'" class="no-wrap ml-2" variant="danger" v-b-popover.hover="'Delete'"
                      style="margin-left: 5px" size="sm" @click="deleteData(props.row.id)">
                      <span class="fe fe-trash-2"></span>
                    </b-button> -->
									</span>
									<span v-else-if="props.column.field == 'title'" class="vgt-header-cell" :title="props.row.title">
										<span v-bind:id="'title-' + props.row.id">
											{{ props.row.title.length > 13 ? props.row.title.slice(0, 13) + '...' : props.row.title }}
										</span>
										<b-tooltip :target="'title-' + props.row.id">
											<span>
												{{ props.row.title }}
											</span>
										</b-tooltip>
									</span>
									<span v-else-if="props.column.field == 'total'"> Rp. {{ convertNumber(props.row.total) }} </span>
									<!-- <span v-else-if="props.column.field == 'title'">
                    {{ props.row.title }}
                    <span v-if="props.row.is_active === true" class="badge bg-success-soft">ACTIVE</span>
                  </span> -->
									<span v-else-if="props.column.field == 'year'">
										{{ props.row.year }}
										<span v-if="props.row.is_default === true" class="badge bg-info-soft">Budget DEFAULT</span>
										<!-- <span v-if="props.row.is_active === true" class="badge bg-success-soft">ACTIVE</span> -->
										<!-- <span v-else>-</span> -->
									</span>
									<span v-else-if="props.column.field == 'departments'">
										{{ props.row.departments }}
									</span>
									<span v-else-if="props.column.field == 'is_active'">
										<!-- Toggle activation -->
										<ToggleSwitch
											v-if="isUpdate"
											v-model="props.row.is_active"
											@change="(v) => handleToggleChange(v, props.row.id, props.row)"
										/>
										<ToggleSwitch v-else v-model="props.row.is_active" />
									</span>
								</template>
								<template slot="pagination-bottom" slot-scope="props">
									<div class="d-flex justify-content-end">
										<div>
											<b-pagination
												:value="1"
												:total-rows="listTable.totalItems"
												:per-page="body.pageSize"
												first-number
												last-number
												align="right"
												prev-class="prev-item"
												next-class="next-item"
												class="mr-3 mb-4 mt-0"
												@input="(value) => props.pageChanged({ currentPage: value })"
											>
											</b-pagination>
										</div>
									</div>
								</template>
							</vue-good-table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ModalNotification
			@hide-modal="hideModalNotification"
			ref="modalNotification"
			:department="selectedDepartment"
			:listDepartment="listDepartment"
			:type="notificationType"
			:recipients="notificationRecipients"
			:plan="selectedPlan"
		/>
		<b-modal id="modal-import" hide-footer title="Import Form">
			<div class="form-group">
				<label>Title</label>
				<input type="text" class="form-control" v-model="bodysend.title" :class="{ 'is-invalid': errors_.title }" />
				<div class="invalid-feedback">{{ errors_.title }}</div>
			</div>

			<div class="form-group">
				<label>Year</label>
				<date-picker
					class="w-100"
					type="year"
					valueType="format"
					v-model="bodysend.year"
					:class="{ 'is-invalid': errors_.year }"
				/>
				<div class="invalid-feedback">{{ errors_.year }}</div>
			</div>

			<div class="form-group">
				<label>Fund Center</label>
				<input type="hidden" v-model="this.body.fund_center_id" />
				<input
					type="text"
					class="form-control"
					v-model="this.fundCenterName"
					disabled
					:class="{ 'is-invalid': errors_.fund_center }"
				/>
				<div class="invalid-feedback">{{ errors_.fund_center }}</div>
			</div>

			<div class="form-group">
				<label>Import File</label>
				<input type="file" class="form-control" @change="fileUpload" :class="{ 'is-invalid': errors_.file }" />
				<div class="invalid-feedback">{{ errors_.file }}</div>
			</div>

			<div class="float-end">
				<button class="btn btn-primary" type="button" disabled v-if="isLoading">
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					Loading...
				</button>
				<b-button variant="primary" @click="createBudget" v-else>Save</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import ModalNotification from '@/views/budgetPlan/components/ModalNotification.vue';
import axiosIns from '@/api/axios';
import moment from 'moment';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import $router from 'v-calendar/lib/v-calendar.umd';
export default {
	components: {
		ToggleSwitch,
		ModalNotification,
	},
	computed: {
		isAllSelected() {
			return this.formFilter.department.length === this.listDepartment.length;
		},
		listTable() {
			let data = this.$store.getters['budgetPlan/listData'];
			return data;
		},
		listFundCenter() {
			return this.$store.getters['fundCenter/listData'];
		},
		listDepartment() {
			return this.$store.getters['budgetPlan/listDepartment']
				.sort((a, b) => a.department_code.localeCompare(b.department_code)) // ASC sort
				.map((items) => ({
					label: `${items.department_code} - ${items.organization}`,
					value: items.id,
					row: items,
				}));
		},
		canLockUnlock() {
			return this.$store.getters['role/isSuperAdmin'] || this.$store.getters['role/isAdmin'];
		},
		canSendNotif() {
			return this.$store.getters['role/isSuperAdmin'] || this.$store.getters['role/isAdmin'];
		},
		canClone() {
			return this.$store.getters['role/isSuperAdmin'] || this.$store.getters['role/isAdmin'];
		},
		canReply() {
			return (
				this.listDepartment.filter((item) => item.value == this.selectedDepartment)?.[0]?.row.canReply &&
				!this.$store.getters['role/isViewer']
			);
		},
		canRequestApproval() {
			return this.$store.getters['role/isUser'];
		},
		canRequestClone() {
			return this.$store.getters['role/isUser'];
		},
	},
	data() {
		return {
			fundCenterName: '',
			isDepartmentError: false,
			value: [],
			options: [],
			listDataYear: [],
			listDataDepartment: [],
			listDataDepartmentError: [],
			formFilter: {
				department: [],
				year: '',
			},

			activePlan: [],
			isLoading: false,
			isOnToggleSwitch: false,
			role_id: '',
			body: {
				pageNumber: 1,
				pageSize: 10,
				search: '',
				field: '',
				order: '',
				fund_center_id: '',
			},
			body_create: {
				title: '',
				year: '',
				is_active: false,
				fund_center: '',
				fund_center_id: '',
				opex: [],
				capex: [],
				sum_capex: 0,
				sum_opex: 0,
			},
			bodysend: {
				fund_center_id: '1',
				fund_center: '7003.122',
				year: '',
				is_active: false,
				title: '',
				description: '',
				files: '',
			},
			objs: {
				file: null,
				sample: '/src/assets/budget_plan_template.xlsx',
			},
			columns: [
				{
					label: 'Title',
					field: 'title',
					sortable: false,
					thClass: 'table-header w-auto text-muted font-weight-bold',
					tdClass: 'w-autocolor-secondary align-middle',
				},
				{
					label: 'Budget Total',
					field: 'total',
					thClass: 'table-header w-auto text-muted font-weight-bold',
					tdClass: 'w-autocolor-secondary align-middle',
				},
				{
					label: 'Budget Year',
					field: 'year',
					thClass: 'table-header w-auto text-muted font-weight-bold',
					tdClass: 'w-autocolor-secondary align-middle',
				},
				{
					label: 'Departments',
					field: 'departments',
					sortable: false,
					thClass: 'table-header w-auto text-muted font-weight-bold',
					tdClass: 'w-autocolor-secondary align-middle',
				},

				{
					label: 'Version',
					field: 'version',
					sortable: false,
					thClass: 'table-header w-auto text-muted font-weight-bold',
					tdClass: 'w-autocolor-secondary align-middle',
				},
				// {
				//   label: "Status",
				//   field: "is_active",
				//   thClass: "table-header w-auto text-muted font-weight-bold",
				//   tdClass: "w-autocolor-secondary align-middle",
				// },
				{
					label: 'Budget Active',
					field: 'is_active',
					sortable: false,
					thClass: 'table-header w-auto text-muted font-weight-bold',
					tdClass: 'w-autocolor-secondary align-middle',
				},
				{
					label: 'Action',
					field: 'action',
					sortable: false,
					thClass: 'table-header w-auto text-muted font-weight-bold',
					tdClass: 'w-autocolor-secondary align-middle',
				},
			],
			years: ['2023', '2024', '2025'],
			departments: ['Finance', 'HR', 'IT', 'Marketing'],
			filters: {
				year: null,
				title: '',
				department: null,
			},
			isRead: false,
			isCreat: false,
			isUpdate: false,
			isDelete: false,
			selectedDepartment: null,
			notificationType: 'reminder',
			notificationRecipients: [],
			file: null,
			errors_: {},
			selectedPlan: null,
		};
	},
	async mounted() {
		await this.checkPermission();
		await this.getActivePlan();
		await this.getListDepartment().then(() => {
			if (this.listDepartment.length > 0) {
				const selectedDepartment = this.listDepartment.find(
					(e) => e.row?.department_code === this.activePlan?.fund_center?.department_code
				);
				this.body.fund_center_id = selectedDepartment?.value;
				this.isLoading = true;
				this.body.dept = selectedDepartment?.value;
				this.selectedDepartment = selectedDepartment?.value;
				this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', selectedDepartment?.value);
			}
		});
		await this.getList();

		//this.getList();
		/*this.getFundCenter();*/

		this.role_id = localStorage.getItem('roles');
		this.getListDataDepartment();
		await this.getListDataYear();
	},
	methods: {
		handleClickCreatePlan() {
			//this.$store.getters['budgetPlan/body_create'] = null
			this.$store.commit('budgetPlan/SET_BODY_CREATE', null);
			this.$router.push('/budget-plan/create');
		},
		hideFormError() {
			this.isDepartmentError = false;
		},
		getListDataDepartmentError() {
			this.listDataDepartmentError = [];
			if (this.formFilter.department.length > 0) {
				this.listDataDepartmentError = this.options.filter((item) => this.formFilter.department.includes(item.id));
			}
			this.isDepartmentError = true;
			/*setTimeout(() => {
        this.isDepartmentError = false
      }, 2000);*/
		},
		async getListDataYear() {
			const response = await axiosIns.get('/plan/year-distinct');
			this.listDataYear = response?.data?.data.map((items) => ({
				label: items.year,
				value: items.year,
			}));
		},
		getListDataDepartment() {
			this.options = this.listDepartment.map((items) => ({
				name: `${items.row.department_code} - ${items.row.organization}`,
				id: items.row.department_code,
				row: items.row,
			}));
		},
		isSelected(option) {
			return this.value.some((sel) => sel.id === option.id);
		},
		toggleSelectAll(e) {
			if (e.target.checked) {
				this.value = [...this.options];
			} else {
				this.value = [];
			}
		},
		customLabel(option) {
			return option.name;
		},
		handleSelect(option) {
			// prevent default click event if needed
		},
		handleRemove(option) {
			// handle removal
		},
		handleSelectAllDepartment() {
			this.listDepartment.forEach((value, index) => {
				this.formFilter.department.push(value.row.department_code);
			});
			const distinct = [...new Set(this.formFilter.department)];
			this.formFilter.department = distinct;
		},
		handleClearSelectedAllDepartment() {
			this.formFilter.department = [];
		},
		async filterBudgetPlanExcel() {
			this.formFilter.department = [];
			if (this.formFilter.year) {
				for (let i = 0; i < this.value.length; i++) {
					this.formFilter.department.push(this.value[i].id);
				}
				this.$swal({
					title: 'Preparing download...',
					text: 'Please wait while we process your request',
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false,
					showConfirmButton: false,
					willOpen: () => {
						this.$swal.showLoading();
					},
				});

				const dt = axiosIns
					.post(
						`/report-budget-plan-custome`,
						this.formFilter,
						{
							responseType: 'blob',
						},
						{
							responseType: 'arraybuffer',
							headers: {
								'Content-Type': 'application/octet-stream',
							},
						}
					)
					.then((res) => {
						const href = URL.createObjectURL(
							new Blob([res.data], {
								type: 'application/octet-stream',
							})
						);
						const link = document.createElement('a');
						link.href = href;
						link.setAttribute('download', `${moment().format()}.xlsx`);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						URL.revokeObjectURL(href);
						this.$swal.close();
					})
					.catch((error) => {
						this.getListDataDepartmentError();
						this.$swal.close();
					});
			} else {
				this.$swal({
					icon: 'warning',
					title: 'Warning',
					text: `Year is required, please select year`,
				});
			}
		},
		handleImport() {
			let deptName = this.listDepartment.filter((item) => this.body.fund_center_id === item.value);
			this.fundCenterName = deptName[0].label || '';

			this.isLoading = false;
			this.$bvModal.show('modal-import');
		},
		async downloadTemplate() {
			const payloadTemplate = {
				id: this.body.fund_center_id,
			};
			const dt = axiosIns
				.post(
					`/report-template`,
					payloadTemplate,
					{
						responseType: 'blob',
					},
					{
						responseType: 'arraybuffer',
						headers: {
							'Content-Type': 'application/octet-stream',
						},
					}
				)
				.then((res) => {
					const href = URL.createObjectURL(
						new Blob([res.data], {
							type: 'application/octet-stream',
						})
					);
					const link = document.createElement('a');
					link.href = href;
					link.setAttribute('download', `Template-Budget-Plan-${moment().format()}.xlsx`);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(href);
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		},
		async getActivePlan() {
			try {
				await this.$store.dispatch('budgetPlan/GET_ACTIVE_PLAN');
				this.activePlan = await this.$store.getters['budgetPlan/activePlan'];
			} catch (error) {
				console.error('Failed to fetch active plan:', error);
			}
		},
		selectFundCenter(value) {
			if (value === null) {
				this.isLoading = true;
				this.body.dept = '';
				this.getList();
			} else {
				this.isLoading = true;
				this.body.dept = value;
				this.getList();
				this.selectedDepartment = value;
			}
			this.$store.dispatch('budgetPlan/SET_SELECTED_FUND_CENTER', value);
		},
		async getListDepartment() {
			try {
				await this.$store.dispatch('budgetPlan/GET_LIST_DEPARTMENT');
			} catch (error) {
				console.error('Failed to fetch year options:', error);
			}
		},
		async checkPermission() {
			const roleName = localStorage.getItem('roles');
			const roleId = await axiosIns.get('/master-role/find-name?name=' + roleName);
			const menuId = await axiosIns.get('/master-menu/find-link?link=' + this.$route.path);
			const payloadPermission = {
				role_id: roleId.data.data[0]?.id || null,
				menu_id: menuId.data.data[0]?.id || null,
			};
			const checkAuth = await axiosIns.post('/master-role/check-permission', payloadPermission);
			if (checkAuth.data.data?.authorization) {
				this.isRead = checkAuth.data.data?.authorization.includes('read');
				this.isCreat = checkAuth.data.data?.authorization.includes('create');
				this.isUpdate = checkAuth.data.data?.authorization.includes('update');
				this.isDelete = checkAuth.data.data?.authorization.includes('delete');
			}
		},
		getList() {
			this.$store.dispatch('budgetPlan/GET_LIST_DATA', this.body);
		},

		getFundCenter() {
			this.$store.dispatch('fundCenter/GET_LIST_DATA', {
				pageNumber: 1,
				pageSize: 1000,
			});
		},

		convertNumber(dat) {
			return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
		},

		async handleToggleChange(val, id, row) {
			// console.log('Toggle berubah:', val, 'ID:', id);
			const confirm = await this.$swal({
				title: `Are you sure to ${val ? 'Active' : 'Inactive'}?`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			});

			if (confirm.isConfirmed) {
				try {
					// Update status via API
					await this.$store.dispatch('budgetPlan/UPDATE_STATUS', { id });

					// Refresh the current page data
					await this.getActivePlan();
					await this.getList();

					this.$swal({
						icon: 'success',
						title: 'Success',
						text: `Budget plan has been successfully ${val ? 'Activated' : 'Deactivated'}.`,
					});
				} catch (error) {
					console.error('Error updating status:', error);
					// If there's an error, revert the toggle
					row.is_active = !val;
					this.$swal({
						icon: 'error',
						title: 'Error',
						text: error.response?.data?.error || 'An error occurred while updating the status.',
					});
				}
			} else {
				// If cancelled, revert the toggle
				row.is_active = !val;
			}
		},

		detailBudget(id) {
			this.$router.push(`/budget-plan/detail?id=${id}`);
		},
		goToHistory(id) {
			this.isLoading = true;
			this.$router.push({
				name: 'budget_plan_histories',
				query: { id },
			});
		},
		compareBudget(id) {
			this.$router.push(`/budget-plan/compare?id=${id}`);
		},
		updateBudget(id) {
			this.$router.push(`/budget-plan/edit?id=${id}`);
		},

		deleteData(id) {
			this.$swal({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store
						.dispatch('budgetPlan/DELETE_DATA', id)
						.then((resp) => {
							this.getList();
							this.$swal
								.mixin({
									toast: true,
									position: 'top-end',
									showConfirmButton: false,
									timer: 3000,
									timerProgressBar: true,
									didOpen: (toast) => {
										toast.addEventListener('mouseenter', this.$swal.stopTimer);
										toast.addEventListener('mouseleave', this.$swal.resumeTimer);
									},
								})
								.fire({
									icon: 'success',
									title: resp.data.message || 'Success Remove Data',
								});
						})
						.catch((error) => {
							this.$swal({
								icon: 'error',
								title: 'Error',
								text: error.response?.data?.error || 'Error while delete data',
							});
						});
				}
			});
		},

		async fileUpload(event) {
			this.bodysend.files = event.target.files;
		},

		createBudget() {
			this.errors_ = {}; // reset error

			if (!this.bodysend.title) this.errors_.title = 'Title wajib diisi';
			if (!this.bodysend.year) this.errors_.year = 'Year wajib dipilih';
			if (!this.body.fund_center_id) this.errors_.fund_center = 'Fund Center wajib ada';
			if (!this.bodysend.files) this.errors_.file = 'File wajib diupload';

			if (Object.keys(this.errors_).length > 0) return; // stop kalau ada error

			this.isLoading = true;
			const formData = new FormData();
			formData.append('title', this.bodysend.title);
			formData.append('year', this.bodysend.year);
			formData.append('is_active', this.bodysend.is_active);
			formData.append('fund_center_id', this.body.fund_center_id);
			formData.append('description', this.bodysend.description);
			for (let file of this.bodysend.files) {
				formData.append('files', file); // note, no square-brackets
			}
			this.$store
				.dispatch('budgetPlan/IMPORT_FILE', formData)
				.then((resp) => {
					this.$bvModal.hide('modal-import');
					this.$router.push('/budget-plan/create');
					/*if(resp?.data?.data){
            //this.body_create = resp.data.data
            //this.$store.dispatch('budgetPlan/SET_BODY_CREATE', resp.data.data); // save to store

            //this.$router.push('/budget-plan/create');
            /!*this.$router.push({
              name: 'budget_plan_import',
              params: { body: resp.data.data }
            });*!/

          }*/
				})
				.catch((err) => {
					this.isLoading = false;
					this.$swal('Error', `${err.response.data.error}`, 'error');
				});
		},

		// Pagination
		onPageChange(payload) {
			this.body.limit = payload.currentPerPage;
			this.body.page = payload.currentPage;
			this.getList();
		},
		onSortChange(params) {
			let sort1 = params[0].field;
			let sort2 = params[0].type;
			this.body.field = sort1;
			if (sort2 == 'none') {
				this.body.order = '';
			} else {
				this.body.order = sort2;
			}
			this.getList();
		},
		async toogleLock(id, isLocked) {
			const warningText = isLocked
				? 'This budget plan will be unlocked and available for editing'
				: 'This budget plan will be locked for editing and available to clone';
			const title = isLocked ? 'Are you sure to unlock this budget plan?' : 'Are you sure to lock this budget plan?';
			this.$swal({
				title,
				text: warningText,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: "Yes, I'm sure!",
				cancelButtonText: 'Cancel',
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$store
						.dispatch('budgetPlan/LOCK_BUDGET_PLAN', { id })
						.then((resp) => {
							this.getList();
							this.$swal
								.mixin({
									toast: true,
									position: 'top-end',
									showConfirmButton: false,
									timer: 3000,
									timerProgressBar: true,
									didOpen: (toast) => {
										toast.addEventListener('mouseenter', this.$swal.stopTimer);
										toast.addEventListener('mouseleave', this.$swal.resumeTimer);
									},
								})
								.fire({
									icon: 'success',
									title: resp.data.message || 'Success locked budget plan',
								});
						})
						.catch((error) => {
							this.$swal({
								icon: 'error',
								title: 'Error',
								text: error.response?.data?.error || 'Error while locking budget plan',
							});
						});
				}
			});
		},
		async cloning(detail) {
			const confirm = await this.$swal({
				title: `Are you sure to clone this budget plan to version ${parseInt(detail.version) + 1}?`,
				text: `This budget will be updated to version ${parseInt(detail.version) + 1} and no longer available for editing.`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, clone it!',
				cancelButtonText: 'Cancel',
			});
			if (!confirm.isConfirmed) return;

			this.isLoading = true;
			try {
				// Fetch budget detail
				await this.$store.dispatch('budgetPlan/GET_BUDGET_DETAIL', detail.id);
				const data = this.$store.getters['budgetPlan/detail'];
				if (!data) {
					this.$swal('Error', 'Failed to retrieve budget plan details', 'error');
					return;
				}

				// Update version
				const payload = {
					id: detail.id,
					body: data,
				};
				await this.$store.dispatch('budgetPlan/UPDATE_VERSIONING', payload);

				this.getList();
				this.$swal
					.mixin({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 3000,
						timerProgressBar: true,
						didOpen: (toast) => {
							toast.addEventListener('mouseenter', this.$swal.stopTimer);
							toast.addEventListener('mouseleave', this.$swal.resumeTimer);
						},
					})
					.fire({
						icon: 'success',
						title: `Budget plan has been cloned to version ${parseInt(detail.version) + 1}`,
					});
			} catch (error) {
				this.$swal({
					icon: 'error',
					title: 'Error',
					text: error.response?.data?.error || 'Error while cloning budget plan',
				});
			} finally {
				this.isLoading = false;
			}
		},

		showModalNotification(type, plan = null) {
			this.notificationType = type;
			this.getUserEmailByDepartment().then(() => {
				setTimeout(() => {
					this.$bvModal.show('modal-notification');
				}, 200);
			});
			this.selectedPlan = plan;
		},

		hideModalNotification() {
			this.$bvModal.hide('modal-notification');
		},

		async getUserEmailByDepartment() {
			const departmentName = this.listDepartment.filter((item) => item.value == this.selectedDepartment)?.[0]?.row
				.department_name;
			const response = await this.$store.dispatch('budgetPlan/GET_USER_BY_DEPARTMENT', {
				department: this.selectedDepartment,
			});

			if (response.length == 0) {
				this.$swal({
					title: 'Warning',
					text: `No user found in "${departmentName}" to send notification`,
					icon: 'warning',
					confirmButtonText: 'OK',
				});
			}
			this.notificationRecipients = response?.map((item) => item.email);
		},
	},
};
</script>

<style>
.hovering:hover {
	background-color: rgb(218, 218, 218);
}

#dropdown-dropleft .dropdown-toggle::after {
	display: none !important;
}

.vgt-responsive {
	min-height: 250px !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option {
	display: flex;
	align-items: center;
}
</style>
<style>
/* Change height */
.multiselect {
	max-height: 15px; /* default is 40px */
	font-size: 12px; /* adjust text size */
}

.multiselect__tags {
	max-height: 15px;
	padding: 6px 8px; /* control inner padding */
}

.multiselect__input {
	height: 3px; /* input height */
}
</style>
